exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".asideClass::-webkit-scrollbar{width:5px;background-color:#fff}.asideClass::-webkit-scrollbar-thumb{width:5px;background-color:#dcdfe6;border-radius:10px}.asideClass{overflow-x:hidden}.mainClass::-webkit-scrollbar{width:8px;height:8px}.mainClass::-webkit-scrollbar-thumb{width:8px;height:8px;background-color:#909399;border-radius:10px}.el-footer,.el-header{color:#333;line-height:60px}.el-header{background-color:#3874f6;color:#fff}.el-aside{background-color:#fff;text-align:left}.el-main{background-color:#eff1f4;color:#333;height:calc(100vh - 80px)}.el-container{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d2e0a3e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index.vue
// module id = 339
// module chunks = 0